import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { BOX_SHADOW, DARKER, PRIMARY, SECONDARY } from "../../const/colors";
import { mobile_normal } from "../../const/fonts";

export const FooContent = styled.div`
    display:none;
    @media screen and (max-width: 768px) {
        display:block;
        background:${SECONDARY};
        position:fixed;
        bottom:0;
        left:0;
        z-index: 10;
        border-top:1px solid ${PRIMARY};
        width:100%;
    }
`;
export const FooRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-top: 0;
    margin-right: 0;
    margin-left: 0;
    & div:nth-child(n){
        // border-right: 1px solid ${PRIMARY};
    }
    & div:last-child{
        // border-right: 0px solid ${PRIMARY};
    }
`;
export const FooCol = styled.div`
    flex: 0 0 auto;
    width: 20%;
    z-index: 1;
    &.auto-col{
        flex: 1 0 0%;
    }
`;
export const FooColCarousel = styled.div`
    flex: 0 0 auto;
    width: 60%;
    & .slick-list{
        overflow:visible;
    }
    & .slick-center{
        transition: 0.7s all;
        svg > path , svg > g path{
            fill:${DARKER}!important;
            color:${DARKER};
          }
        a{
            background:${PRIMARY};
            border-radius: 10px;
            transition: all 0.5s ease 0s;
            transform: translateY(-10px);
            p{
                color:${DARKER};
            }
        }
    }
`;

export const FooColCarouselSimple = styled.div`
    flex: 0 0 auto;
    width: 100%;
    position:relative;
    & .overlay{
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        left:0;
        background: linear-gradient(270deg, #34343445 7%, #1c203e 50%);
    }
`;
export const FooLink = styled(Link)`
    color: white;
    padding: 10px 0px;
    font-weight: bold;
    font-size: 10px;
    text-transform: uppercase;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #14172C;
    > svg{
        width: 25px;
        height: 20px;
        margin-bottom:5px;
        color:${PRIMARY};
    }
    > svg#slots{
        width: 30px;
    }
    > p {
        margin:0;
    }
`;

export const FooDiv = styled.div`
    color: white;
    padding: 10px 0px;
    font-weight: bold;
    font-size: 10px;
    text-transform: uppercase;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #14172C;
    > svg{
        width: 25px;
        height: 20px;
        margin-bottom:5px;
    }
    > svg#slots{
        width: 30px;
    }
    > p {
        margin:0;
    }
`;
